export default "__VITE_ASSET__DIPFHl6v__"